<template>
  <div>
    <div class="title1 text-center">
      <h2>
        <strong>{{ getTitle }}</strong>
      </h2>
    </div>
    <div class="stageContainer">
      <div class="stageLeft">
        <GolfDatePicker class="datePicker" :list-type="this.listType" :rev-confirm-list="revConfirmList" />
      </div>

      <div class="stageRight" v-if="listType === 'REAL'">
        <RealTeeOffPicker :list-type="this.listType" :rev-confirm-list="revConfirmList" />
      </div>
      <div class="stageRight" v-if="listType !== 'REAL'">
        <TeeOffPicker class="teePicker" :list-type="this.listType" :rev-confirm-list="revConfirmList" />
        <CoursePicker class="coursePicker" :list-type="this.listType" :rev-confirm-list="revConfirmList" />
        <!--        <div class="receiptAddButton">-->
        <!--          <b-button block variant="outline-primary">접수 추가</b-button>-->
        <!--        </div>-->
      </div>
    </div>
    <div>
      <ReceiptList class="receiptList" :list-type="this.listType" :rev-confirm-list="revConfirmList" />
    </div>
    <div>
      <ReceiptInfo :list-type="this.listType" />
    </div>

    <!--    <div class="select-form border rounded p-4 mt-5">-->
    <!--      <h4 class="mb-4">안내사항</h4>-->
    <!--      <div class="table-responsive">-->
    <!--        <table class="table">-->
    <!--          <tbody>-->
    <!--            <tr>-->
    <!--              <td style="width: 150px"><b>기본 사항</b></td>-->
    <!--              <td>기본 사항 안내</td>-->
    <!--            </tr>-->
    <!--            <tr>-->
    <!--              <td><b>휴장일</b></td>-->
    <!--              <td>휴장일 안내</td>-->
    <!--            </tr>-->
    <!--            <tr>-->
    <!--              <td><b>확정 안내일</b></td>-->
    <!--              <td>확정 안내일 안내</td>-->
    <!--            </tr>-->
    <!--            <tr>-->
    <!--              <td><b>요금</b></td>-->
    <!--              <td>요금 안내</td>-->
    <!--            </tr>-->
    <!--          </tbody>-->
    <!--        </table>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="buttonGroup">
      <button class="moveButton" @click="nextStage"><span>다음</span></button>
    </div>
  </div>
</template>

<script>
import GolfDatePicker from '@/pages/RevReceiptPage/Component/GolfDatePicker';
import CoursePicker from '@/pages/RevReceiptPage/Component/CoursePicker';
import TeeOffPicker from '@/pages/RevReceiptPage/Component/TeeOffPicker';
import ReceiptList from '@/pages/RevReceiptPage/Component/ReceiptList';
import ReceiptInfo from '@/pages/RevReceiptPage/Component/ReceiptInfo';
import RealTeeOffPicker from '@/pages/RevReceiptPage/Component/RealTeeOffPicker';
import moment from 'moment';
import {getReservText} from '@/util/GolfUtil';
import GeneralUtil from '@/util/GeneralUtil';

export default {
  name: 'RegSelection',
  props: {
    listType: String,
    revConfirmList: Array,
  },
  mixins: [GeneralUtil],
  components: {
    GolfDatePicker,
    CoursePicker,
    TeeOffPicker,
    RealTeeOffPicker,
    ReceiptList,
    ReceiptInfo,
  },
  data() {
    return {
      regBreadcrumb: {
        toplink: 'HOME',
        prevlink: 'GOLF COURSE',
        present: '골프코스',
      },
    };
  },
  computed: {
    getTitle() {
      if (this.listType === 'RECEIPT') {
        return '사전접수';
      } else if (this.listType === 'WAIT') {
        return '잔여접수';
      } else if (this.listType === 'REAL') {
        return '실시간예약';
      } else {
        return '';
      }
    },
  },
  methods: {
    reservText() {
      return getReservText(this.listType);
    },
    nextStage() {
      // 복수 팀 중복

      if (this.revConfirmList.length === 0) {
        this.$bvModal.msgBoxOk('예약정보를 선택해 주세요.', {
          title: '에러',
          okTitle: '확인',
          centered: true,
        });
        return;
      }

      let totalCount = 0;
      this.revConfirmList.forEach(x => {
        totalCount += x.teamCount;
      });

      let msgHead = `예약`;
      if (this.listType === 'RECEIPT' || this.listType === 'WAIT') msgHead = `${this.reservText()}`;
      const WAIT_MAX = 7;
      const RECEIPT_BUBIN_MAX = 14;
      let maxListLength = 0;
      //법인의 사전예약은 14건까지 가능, 그 외는 7건
      if (this.isMyMemTypeBubin && this.listType === 'RECEIPT') {
        maxListLength = RECEIPT_BUBIN_MAX;
      } else {
        maxListLength = WAIT_MAX;
      }

      if (totalCount > maxListLength) {
        this.$bvModal.msgBoxOk(`${msgHead}는 최대 ${maxListLength}건까지 접수가 가능합니다.`, {
          title: '에러',
          okTitle: '확인',
          centered: true,
        });
        return;
      }

      this.$bvModal
        .msgBoxConfirm(
          this.htmlToVNode(
            `총 ${this.revConfirmList.length} 건의 일정을 선택 하셨습니다. <br /> 추가 일정 없이 계속 진행 하시겠습니까?<br/><div style="font-size: 0.8rem; color: #555555; margin-top: 1rem"> ※ 내장자가 다른 일정은 제외 후 별도 접수 진행<br/>※ 여러 일정일 시 복수 일정 선택 후 일괄 접수</div>`,
          ),
          {
            title: `${this.reservText()} 진행`,
            okTitle: '확인',
            cancelTitle: '취소',
            centered: true,
          },
        )
        .then(value => {
          if (value === true) {
            this.$EventBus.$emit('NextStage');
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.stageContainer {
  display: flex;
  align-items: flex-start;
}

.stageLeft {
  flex: 0 0 auto;
  //background-color: red;
}

.stageRight {
  flex: 1 1 auto;
  min-width: 0;
  max-height: 600px;

  //background-color: blue;
}

// 1200px 이상: 캘린더 폭이 충분히 확보되므로 50:50 고정 비율로 전환
@media (min-width: 1200px) {
  .stageLeft {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .stageRight {
    flex: 1 1 50%;
    min-width: 0;
  }
}

.datePicker {
}

.coursePicker {
}

.teePicker {
}

.receiptList {
}

hr {
  margin: 0 1rem;
}

.buttonGroup {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  width: 15%;

  .moveButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    width: 100%;
    margin: 1rem;
    background-color: #524a3d !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;
    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }

    &:hover {
      background-color: #403a30 !important;
    }
  }
}

.title1 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

@media (max-width: 992px) {
  .title1 {
    display: none;
  }

  .stageContainer {
    padding-top: 2rem;
  }

  .stageContainer {
    display: block;
  }

  .stageLeft {
    max-width: 100%;
    //background-color: red;
  }

  .stageRight {
    width: 100%;
    max-height: 600px;

    //background-color: blue;
  }

  .buttonGroup {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
    width: 100%;

    .moveButton {
      display: inline-flex;
      align-items: center;
      height: 2.3rem;
      font-size: 0.8rem;
      width: 100%;
      margin: 1rem;
      background-color: #524a3d !important;
      padding: 0px !important;
      color: white;
      border: none;
      outline: none;
      span {
        padding: 0px;
        width: 100%;
        text-align: center;
        padding: 0px !important;
      }

      &:hover {
        background-color: #403a30 !important;
      }
    }
  }
}
</style>
